"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.cExternalInteractionRsvpTypeIdsByType = exports.cExternalInteractionAttendanceTypeIdsByType = exports.cRsvpStatusTypes = exports.cAttendanceTypes = exports.cInteractionDataTablesPerVerb = exports.cInteractionTypeVerbs = void 0;
/**
 * The verbs an InteractionType can use.
 */
exports.cInteractionTypeVerbs = Object.freeze({
    attended: 'attended',
    invited: 'invited',
    volunteered: 'volunteered',
    opened: 'opened',
    watched: 'watched',
    read: 'read',
    RSVPed: 'RSVPed',
});
exports.cInteractionDataTablesPerVerb = Object.freeze((_a = {},
    _a[exports.cInteractionTypeVerbs.attended] = 'externalInteractionsAttendanceData',
    _a[exports.cInteractionTypeVerbs.RSVPed] = 'externalInteractionsRsvpData',
    _a[exports.cInteractionTypeVerbs.invited] = 'externalInteractionsInvitationsData',
    _a));
exports.cAttendanceTypes = Object.freeze({
    'in-person': 'in-person',
    remote: 'remote'
});
exports.cRsvpStatusTypes = Object.freeze({
    'accepted': 'accepted',
    'declined': 'declined',
    'tentative': 'tentative',
});
/**
 * The IDs of external interaction attendance types as stored in
 * `externalInteractionsAttendanceTypes`.
 */
exports.cExternalInteractionAttendanceTypeIdsByType = Object.freeze((_b = {},
    _b[exports.cAttendanceTypes['in-person']] = 1,
    _b[exports.cAttendanceTypes.remote] = 2,
    _b));
/**
 * The IDs of external interaction attendance types as stored in
 * `externalInteractionsAttendanceTypes`.
 */
exports.cExternalInteractionRsvpTypeIdsByType = Object.freeze((_c = {},
    _c[exports.cRsvpStatusTypes.accepted] = 1,
    _c[exports.cRsvpStatusTypes.declined] = 2,
    _c[exports.cRsvpStatusTypes.tentative] = 3,
    _c));
